import MainTestScenario from './MainTestScenario';
import { constants, Globals } from '../../../../misc/helpers';

export default class MainTestScenarioSteps12 {
	constructor(private mainScenario: MainTestScenario, private onDone: (indx: number, aarReady12: boolean) => void, public showFailedAar: () => void) {
	}

	start() {
		this.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BleedoutTimer, {
			dispatch: this.mainScenario.gameManager.customData.dispatch,
			onTimeRanOut: () => {
				this.showFailedAar();
			},
			isActive: true
		});
		if(this.mainScenario.skipBCK === true) {
			this.step2ApplySecondTourniquete();
		}
		else {
			this.step1ShowBleedingControlKit();
		}
	}

	private step1ShowBleedingControlKit() {
		var context = this;
		context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.BleedingControlKit, {
			onSelectionChanged: (index: number) => {
				if(!context.mainScenario.gameManager || !context.mainScenario.gameManager.UiManager) {
					return;
				}
				if(index === 1) {
					context.step1TourniqueteSelected();
				} 
				else if(index === 2) {
					context.onDone(-2, false);
				}
				else if(index === 0) {
					context.onDone(-3, false);
				}
				else {
					context.onDone(index, false);
					// context.step1TourniqueteNotSelected();
				}
			}
		});
	}

	private step1TourniqueteSelected() {
		this.step2ApplySecondTourniquete();
	}
	// private step1TourniqueteNotSelected() {
	// 	var context = this;
	// 	context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.BleedingControlKit);
	// 	this.mainScenario.showJITFeedback('This choice is incorrect', () => context.step1ShowBleedingControlKit());
	// }

	private step2ApplySecondTourniquete() {
		var context = this;

		context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.BinaryQuestion, {
			title: 'Would you like to apply the second tourniquete above the wound?',
			correctButton: {
				title: 'Yes',
				onClick: () => context.mainScenario.onAnsweredCorrectly('MainTestScenarioSteps12.step2ApplySecondTourniquete', () => context.step2ApplySecondTourniqueteYes())
			},
			incorrectButton: {
				title: 'No',
				onClick: () => context.step2ApplySecondTourniqueteNo()
			}
		});
	}

	private step2ApplySecondTourniqueteYes() {
		var context = this;
		context.step3TourniqueteInteraction();
		this.mainScenario.playSound('Step-11', '1', () => {
			context.mainScenario.playSequence('VictimPlayLips');

			this.mainScenario.playSound('Step-11', '2', () => {
				context.mainScenario.playSequence('VictimStopLips');

		});
	});
	}

	private step2ApplySecondTourniqueteNo() {
		this.step1ShowBleedingControlKit();
		// var context = this;
		// this.mainScenario.showJITFeedback('This choice is incorrect', () => context.step2ApplySecondTourniquete());
	}

	private step3TourniqueteInteraction() {
		var context = this;
		this.mainScenario.gameManager.UiManager.hideaAllUis();
		this.mainScenario.playSequence('TourniqueteSetup', null, () => {
			context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.TourniquetePlacement, {
				dispatch: this.mainScenario.gameManager.customData.dispatch,
				correctIndex1: context.mainScenario.correctT2,
				wrongIndex: context.mainScenario.wrongT1,
				closeIndex: context.mainScenario.closeT1,
				locations: context.mainScenario.locations2,
				isTestScenario: true,
				isSceneA: context.mainScenario.SceneAT,
				isSceneB: context.mainScenario.SceneBT,
				isSceneC: context.mainScenario.SceneCT,
				isSceneD: context.mainScenario.SceneDT,
				onDone: (selectedNumber: number, isCorrect: boolean) => {
					context.mainScenario.selectedTourniquetIndex = selectedNumber;
					if(isCorrect) {
						context.step3TourniqueteInteractionCorrect();
					} else {
						context.step3TourniqueteInteractionIncorrect();
					} 
				}
			});
		});
	}

	private step3TourniqueteInteractionCorrect() {
		var context = this;
		context.mainScenario.aarApplySecondTourniquete = true;
		this.mainScenario.gameManager.UiManager.hideaAllUis();
		this.mainScenario.playSound('Step-12', '1', () => {
			this.mainScenario.playSound('Step-12', '2', () => {
			context.onDone(-1, true);
		});
	});
		// context.mainScenario.playSequence('Steps12Cinematic', null, () => {
		// 	context.onDone();
		// });
	}
	private step3TourniqueteInteractionIncorrect() {
		var context = this;
		context.mainScenario.aarApplySecondTourniquete = false;
		this.mainScenario.gameManager.UiManager.hideaAllUis();
		this.mainScenario.playSound('Step-12', '1', () => {
			context.mainScenario.playSequence('VictimPlayLips');

			this.mainScenario.playSound('Step-12', '2', () => {
				context.mainScenario.playSequence('VictimStopLips');

			context.onDone(-1, true);
		});
	});
		// var context = this;
		// this.mainScenario.showJITFeedback('This choice is incorrect', () => context.step3TourniqueteInteraction());
	} 
}